export class Clones {

  constructor(container) {
    this._elem = container.querySelector('.block-filter__choices');
  }

  getClones() {
    return Array.from(this._elem.children);
  }

  add(html) {
    this._elem.innerHTML = html;
  }

  removeAll() {
    const clones = this.getClones();
    if (clones.length === 0) {
      return;
    }
    clones.forEach((clone) => {
      this.remove(clone);
    });
  }

  remove(elem) {
    elem.remove();
  }
}
